import React, { useEffect, useState } from "react";
import moment from "moment";
import column from "../../columns/payments/payments";
import { GetPaymentList } from "../../api/request/payments/payments";
import SkeletonTable from "../../components/table/SkeletonTable";
import GlobalTooltip from "../../components/common/GlobalTooltip";
import Eye from "../../assets/View";

const Payments = () => {
  const [paymentList, setPaymentList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getPaymentList = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetPaymentList();
      if (data.status) {
        setPaymentList(
          data?.data?.map((item) => {
            return {
              ...item,
              name: item?.files?.service_name_slug,
              file_number: item?.files?.file_number,
              status: getStatus(item),
              created_at: item?.created_at
                ? moment(item?.created_at).format("lll")
                : "--",
              action: item?.files?.invoice_pdf?.url ? (
                <GlobalTooltip title={"View Invoice"}>
                  <a
                    href={item?.files?.invoice_pdf?.url || "#"}
                    target={item?.files?.invoice_pdf?.url && "_blank"}
                    className="font-semibold text-blue-500 w-fit inline-block"
                  >
                    <Eye />
                  </a>
                </GlobalTooltip>
              ) : (
                <div className="cursor-not-allowed">
                  <Eye />
                </div>
              ),
            };
          })
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPaymentList();
  }, []);

  const getStatus = (item) => (
    <>
      {item?.reason ? (
        <p className="font-bold uppercase text-red-600" title={item?.reason}>
          Rejected
        </p>
      ) : (
        <p
          className={`font-bold uppercase ${item?.status === "paid" ? "text-green-500" : "text-red-600"
            }`}
        >
          {item?.status}
        </p>
      )}
    </>
  );

  return (
    <div className="border rounded-xl bg-white">
      <div className="flex justify-between mx-5 mt-5">
        <p className="title">Payments Report</p>
      </div>

      <div className="mt-5">
        <SkeletonTable
          columns={column}
          data={paymentList}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default Payments;
